import React, { Component } from 'react';
import { Big3Common, bootstrap } from '../../../js/IncludeManager'
/* 개발담당:양유빈
 * 화면기능:일괄주문위한 파일업로드
 * 세부설명:
*/

export class ExcelUpLoad extends Component {
    static displayName = ExcelUpLoad.name;

    constructor(props) {
        super(props);
        this.state = {
            Title: "",
            FileName: "",
            UpLoading: false
        };
        this.ref_ExcelUpLoad = React.createRef();
        this.handleChange = this.handleChange.bind(this);
        this.handleDelete_Click = this.handleDelete_Click.bind(this);
        this.handleExcelUpLoad_Click = this.handleExcelUpLoad_Click.bind(this);
    }
    TempFileList = [];
    UpLoadFileContent = "";
    //초기화
    componentDidMount() {
    }
    initExcelUpLoad = () => {
        this.setState({
            Title: "",
            FileName: "",
            UpLoading: false
        });
        document.getElementById("file-upload").value = "";
        this.TempFileList = [];
        this.UpLoadFileContent = "";
        return false;
    }
    handleChange(event) {
        
        this.TempFileList = event.target.files;
        let _this = this;
        if (this.TempFileList.length > 0 && (!this.TempFileList[0].name.includes("xls") || !this.TempFileList[0].name.includes("xlsx"))) {
            this.TempImageList = [];
            alert("엑셀 파일만 등록 가능합니다.");
            return false;
        }
        else {
            let reader = new FileReader();
            let SelectFile = this.TempFileList[0];
            reader.addEventListener('load', function (event) {
                if (event.type === "load") {
                    let FileContent = {
                        FileSeq: 1,
                        BlobData: this.result,
                        Size: SelectFile.size,
                        FileName: SelectFile.name,
                        Type: SelectFile.type,
                        CrudType: "C",
                        Guid: Big3Common.getGuid(),
                        Storage: Big3Common.WebConfig.FileStoragePath.Temp,
                        ExtensionAdd:"Y"
                    }
                    _this.UpLoadFileContent = FileContent;
                }
            }, false)
            reader.readAsDataURL(SelectFile);
            this.setState({ FileName: SelectFile.name });
        }
        return false;
    }
    //업로드 취소
    handleDelete_Click = (event) => {
        this.TempFileList = [];
        this.setState({ FileName: "" });
        event.preventDefault();
    }
    //엑셀파일 업로드
    handleExcelUpLoad_Click = async () => {
        if (this.TempFileList.length === 0) {
            alert("파일을 첨부하여 주세요.");
            return false;
        }
        try {
            this.setState({ UpLoading: true });
            let result = await Big3Common.FileUpLoadModule("api/MyPage/ExcelOrder/RegisterExcelFile", this.UpLoadFileContent);
            if (result) {
                const Extention = this.UpLoadFileContent.FileName;
                if (Big3Common.Util.isEmptyOrNull(Extention)) {
                    alert("첨부파일을 확인하여 주세요.");
                    return false;
                }
                let Data = await Big3Common.Post('api/MyPage/ExcelOrder/RegisterExcelFileOrder',
                    {
                        guid: this.UpLoadFileContent.Guid,
                        extention: Extention.split('.')[1]
                    });
                if (Data.codeName === Big3Common.ResultCode.Success) {
                    const DataTable = JSON.parse(Data.dataTable);
                    let modalID = this.props.id;
                    var modalEl = document.getElementById(modalID);
                    var thismodal = bootstrap.Modal.getInstance(modalEl);
                    thismodal.hide();
                    Big3Common.HistoryBackToClearBackdoor();

                    if (this.props.CallBack !== undefined) {
                        this.props.CallBack(DataTable);
                    }
                }
                else {
                    alert(Data.message);
                }
            }
            else {
                alert("엑셀파일을 읽지 못했습니다.\n확인 하시고 다시등록해 주세요.");
            }
        }
        catch (e) {
            console.log("handleExcelUpLoad_Click", e);
        }
    }
    render() {
        this.UpLoadButton = () => {
            if (this.state.UpLoading === true) {
                return (
                    <button type="button" className="m_btn" disabled>
                        <span className="spinner-border spinner-border-sm" aria-hidden="true"></span>
                        <span role="status">Uploading..</span>
                    </button>
                )
            }
            else {
                return (
                    <button type="button" className="m_btn" onClick={() => this.handleExcelUpLoad_Click()}>
                        파일업로드
                    </button>
                )
            }
        }
        return (
            <form>
                <div ref={this.ref_ExcelUpLoad} className="modal fade" tabIndex="-1" style={{ zIndex: this.props.zIndex === undefined ? 2000 : this.props.zIndex }} id={this.props.id} data-bs-keyboard="false" data-bs-backdrop="static">
                    <div className="modal-dialog modal-dialog-centered ">
                        <div className="modal-content">
                            <div className="modal-header EmpDtl_modal_header">
                            <div className="modal-title">일괄주문 등록</div>
                                <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                            </div>
                            <div className="order_data order_data2">
                                <div className="txt2">
                                엑셀로 직접 작성하신 파일을 올려주시기바랍니다.<br />확장자:xlsx , xls
                                </div>
                                <label htmlFor="file-upload" className="custom-file-upload">
                                    파일등록
                                </label>
                                <input 
                                    id="file-upload"
                                    type="file"
                                    accept="xlsx"
                                    onChange={this.handleChange}
                                    disabled={this.state.UpLoading}
                                />
                                <div>
                                    {this.state.FileName !== "" ? <div className="excel_file_name">{this.state.FileName}<p className="file_delete" onClick={(e) => {this.handleDelete_Click(e) } }></p></div> : ""}
                                </div>
                                <div className="modal-footer notice_modal_footer">
                                    {this.UpLoadButton() }
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                 
            </form>
        );
    }
}
